var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex sm12 m12" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                wrap: "",
                "mt-4": "",
                "mb-2": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm9: "", md9: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            style: { width: "200px" },
                            attrs: {
                              label: "Integrador",
                              "prepend-icon": "home_repair_service",
                              items: _vm.integrador,
                              "item-text": "nombre",
                              "no-data-text": "Sin resultados",
                              "item-value": "motor"
                            },
                            model: {
                              value: _vm.seleccionarintegrador,
                              callback: function($$v) {
                                _vm.seleccionarintegrador = $$v
                              },
                              expression: "seleccionarintegrador"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            style: { width: "200px" },
                            attrs: {
                              label: "Patente",
                              maxlength: "6",
                              "prepend-icon": "home_repair_service",
                              rules: [_vm.patenteRule]
                            },
                            on: { input: _vm.validarPatente },
                            model: {
                              value: _vm.seleccionarpatente,
                              callback: function($$v) {
                                _vm.seleccionarpatente = $$v
                              },
                              expression: "seleccionarpatente"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            style: { width: "200px" },
                            attrs: {
                              label: "Tipo Evento",
                              "prepend-icon": "home_repair_service",
                              items: _vm.tiposEventos,
                              "no-data-text": "Sin resultados",
                              "item-text": "nombre",
                              "item-value": "id"
                            },
                            model: {
                              value: _vm.eventos,
                              callback: function($$v) {
                                _vm.eventos = $$v
                              },
                              expression: "eventos"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            style: { width: "200px" },
                            attrs: {
                              label: "Velocidad >=",
                              "prepend-icon": "speed",
                              type: "text",
                              maxlength: "3",
                              rules: [_vm.velocidadRule]
                            },
                            on: { input: _vm.validarVelocidad },
                            model: {
                              value: _vm.velocidad,
                              callback: function($$v) {
                                _vm.velocidad = $$v
                              },
                              expression: "velocidad"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            style: { width: "200px" },
                            attrs: {
                              label: "Fecha Desde",
                              type: "date",
                              max: _vm.now,
                              min: _vm.minFecha,
                              "prepend-icon": "home_repair_service"
                            },
                            model: {
                              value: _vm.fechadesde,
                              callback: function($$v) {
                                _vm.fechadesde = $$v
                              },
                              expression: "fechadesde"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "time",
                              label: "Hora",
                              "background-color": "white",
                              placeholder: "HH:mm:ss"
                            },
                            model: {
                              value: _vm.hourfin,
                              callback: function($$v) {
                                _vm.hourfin = $$v
                              },
                              expression: "hourfin"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm3: "",
                            md3: "",
                            layout: "",
                            "mt-2": ""
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "" },
                              on: { click: _vm.buscarDatos }
                            },
                            [
                              _c("v-icon", { attrs: { color: "#27488e" } }, [
                                _vm._v("search")
                              ]),
                              _vm._v("\n                \n              "),
                              _c("span", [_vm._v("Filtrar")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "" },
                              on: { click: _vm.limpiarCampos }
                            },
                            [
                              _c("v-icon", { attrs: { color: "#27488e" } }, [
                                _vm._v("clear")
                              ]),
                              _vm._v("\n                \n              "),
                              _c("span", [_vm._v("Limpiar")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            layout: "",
            row: "",
            "align-center": ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "", sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                staticClass: "search-bar",
                style: { width: "335px" },
                attrs: {
                  name: "busqueda",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.buscador,
                  callback: function($$v) {
                    _vm.buscador = $$v
                  },
                  expression: "buscador"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs3: "",
                layout: "",
                row: "",
                "justify-start": "",
                "align-center": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "" },
                  on: { click: _vm.onQuickFilterChanged }
                },
                [
                  _c("v-icon", { attrs: { color: "#27488e" } }, [
                    _vm._v("search")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", [_vm._v("Buscar")])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "" },
                  on: { click: _vm.limpiarCampos2 }
                },
                [
                  _c("v-icon", { attrs: { color: "#27488e" } }, [
                    _vm._v("clear")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", [_vm._v("Limpiar")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                layout: "",
                row: "",
                "justify-end": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: { click: _vm.getCSV }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar"),
                    _c("br"),
                    _vm._v("CSV")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c("MantenedorGridVerDetalle", {
        staticClass: "ag-theme-material",
        attrs: { "grid-options": _vm.gridOptions }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }